export const getEarlySettlementReasons = (customerType: string): { label: string; value: string }[] => {
    // "Retail" : 4 reasons:
    const retailReasons = [
        { label: 'Crédit', value: 'CREDIT' },
        { label: 'Donation/héritage', value: 'DONATION_HERITAGE' },
        { label: 'Epargne', value: 'SAVINGS' },
        { label: 'Gain aux jeux', value: 'WINNING' },
    ];
    // "BIC/BA/BNC": 8 reasons:
    const bReasons = [
        { label: 'Donation/héritage', value: 'DONATION_HERITAGE' },
        { label: 'Epargne', value: 'SAVINGS' },
        { label: 'Gain aux jeux', value: 'WINNING' },
        { label: "Ventes d'un bien immobilier", value: 'PROPERTY_RESALE' },
        { label: 'Crédit', value: 'CREDIT' },
        { label: 'Vente de parts de société', value: 'SALE_COMPANY_SHARES' },
        { label: 'Distribution de dividendes', value: 'DIVIDENDS' },
        { label: 'Trésorerie', value: 'CASH_FLOW' },
    ];
    // "PM": 5 reasons:
    const pmReasons = [
        { label: "Ventes d'un bien immobilier", value: 'PROPERTY_RESALE' },
        { label: 'Crédit', value: 'CREDIT' },
        { label: 'Vente de parts de société', value: 'SALE_COMPANY_SHARES' },
        { label: 'Distribution de dividendes', value: 'DIVIDENDS' },
        { label: 'Trésorerie', value: 'CASH_FLOW' },
    ];
    switch (customerType) {
        case 'Retail':
            return retailReasons;
        case 'BIC':
        case 'BA':
        case 'BNC':
            return bReasons;
        case 'PM':
            return pmReasons;
        default:
            return [];
    }
};
